import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { TPostArchiveWorkerBankAccountRequest } from "./postArchiveWorkerBankAccountRequestSchema";

export interface IPostArchiveWorkerBankAccountResponse {
  readonly archivedBankAccountId: string;
  readonly bankAccountId: string;
}

export const postArchiveWorkerBankAccount = (axios: IAxiosInstance) => {
  return async (data: TPostArchiveWorkerBankAccountRequest) => {
    const response = await axios.noRetry.post<
      ZealApiResponse<IPostArchiveWorkerBankAccountResponse>
    >("/api/archiveWorkerBankAccount", { ...data });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
